export default __webpack_public_path__ + "static/media/game_2_3.d3707d70.png";